import gql from 'graphql-tag';

/**
 * The requesting user's Ask threads, newest first. Every query and mutation on this surface is
 * implicitly scoped to the requesting user, so there is no user filter to pass — you only ever
 * see your own threads.
 *
 * `scope` narrows to one context. `{ type: ORG }` also matches threads stored without a scope,
 * which predate scope persistence and behaved as org-wide asks.
 */
export const listAgentThreads = gql`
  query ListAgentThreadsQuery($input: ListAgentThreads!) {
    listAgentThreads(input: $input) {
      threads {
        id
        title
        scopeType
        scopeId
        createdAt
        updatedAt
      }
      hasMore
    }
  }
`;

/**
 * One thread with its history, grouped by run.
 *
 * `attachments`, `proposalJson` and `feedback` are deliberately not selected. Nothing in the Ask
 * panel renders a proposal or a rating, and an attachment arrives as an S3 key with no URL, which
 * the transcript cannot display — see `toAskThreadMessages`.
 */
export const getAgentThread = gql`
  query GetAgentThreadQuery($input: GetAgentThread!) {
    getAgentThread(input: $input) {
      thread {
        id
        title
        scopeType
        scopeId
        createdAt
        updatedAt
      }
      runs {
        runId
        entries {
          type
          text
        }
      }
      hasMore
    }
  }
`;
